"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _styledBase = _interopRequireDefault(require("@emotion/styled-base"));

var _emotionTheming = require("emotion-theming");

var _spinner = _interopRequireWildcard(require("@tablekit/spinner"));

var _theme = require("@tablekit/theme");

var _types = require("../types");

var _core = require("@emotion/core");

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _EMOTION_STRINGIFIED_CSS_ERROR__() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}

var LoadingDiv = (0, _styledBase["default"])("div", {
  target: "e1m2k62f0",
  label: "LoadingDiv"
})(process.env.NODE_ENV === "production" ? {
  name: "1apsuzy",
  styles: "margin-top:2px;position:absolute;left:50%;top:50%;transform:translate(-50%,-50%);"
} : {
  name: "1apsuzy",
  styles: "margin-top:2px;position:absolute;left:50%;top:50%;transform:translate(-50%,-50%);",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
});
LoadingDiv.displayName = 'ButtonLoadingWrapper';

var darkTheme = _defineProperty({
  colors: _theme.DARK_COLORS
}, _spinner.spinnerThemeNamespace, _spinner.spinnerDarkTheme);

var classicTheme = _defineProperty({
  colors: _theme.CLASSIC_COLORS
}, _spinner.spinnerThemeNamespace, _spinner.spinnerClassicTheme);

var whiteSpinnerTheme = _defineProperty({}, _spinner.spinnerThemeNamespace, {
  fillColor: 'white'
});

var classicGreySpinnerTheme = _defineProperty({}, _spinner.spinnerThemeNamespace, {
  fillColor: _theme.COLORS.GRAY.L3
});

var darkGreySpinnerTheme = _defineProperty({}, _spinner.spinnerThemeNamespace, {
  fillColor: _theme.COLORS.GRAY.L6
});

var invertClassicAppearances = [_types.APPEARANCES.PRIMARY, _types.APPEARANCES.WARNING, _types.APPEARANCES.DANGER, _types.APPEARANCES.SUCCESS];
var invertDarkAppearances = [_types.APPEARANCES.OUTLINE, _types.APPEARANCES.SUBTLE];

var LoadingSpinner = function LoadingSpinner(_ref) {
  var _ref$appearance = _ref.appearance,
      appearance = _ref$appearance === void 0 ? _types.APPEARANCES.PRIMARY : _ref$appearance,
      _ref$isDisabled = _ref.isDisabled,
      isDisabled = _ref$isDisabled === void 0 ? false : _ref$isDisabled,
      size = _ref.size;
  var theme = (0, _emotionTheming.useTheme)();
  var spinnerTheme = classicTheme;

  if (theme.isDark) {
    if (isDisabled) {
      spinnerTheme = classicGreySpinnerTheme;
    }

    if (isDisabled && appearance === _types.APPEARANCES.INVERSE) {
      spinnerTheme = classicTheme;
    }

    if (!isDisabled && invertDarkAppearances.indexOf(appearance) !== -1) {
      spinnerTheme = darkTheme;
    }
  } else {
    if (isDisabled) {
      spinnerTheme = darkGreySpinnerTheme;
    }

    if (isDisabled && appearance === _types.APPEARANCES.INVERSE) {
      spinnerTheme = classicTheme;
    }
  }

  if (!isDisabled && invertClassicAppearances.indexOf(appearance) !== -1) {
    spinnerTheme = whiteSpinnerTheme;
  }

  return (0, _core.jsx)(_emotionTheming.ThemeProvider, {
    theme: spinnerTheme
  }, (0, _core.jsx)(LoadingDiv, {
    size: size
  }, (0, _core.jsx)(_spinner["default"], {
    size: size
  })));
};

var _default = LoadingSpinner;
exports["default"] = _default;